<template>
  <div class="col-md-12 col-lg-3">
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <div class="menu_sidebar">
      <ul>
        <li>
          <router-link :to="{ name: 'my-orders' }"
            ><img src="/src/assets/images/order-icon.svg" alt="" />
            <span>Orders</span>
          </router-link>
        </li>

        <li>
          <router-link :to="{ name: 'account-profile' }"
            ><img src="/src/assets/images/profile.svg" alt="" />
            <span>Account Settings</span></router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'customer-wallets' }"
            ><img src="/src/assets/images/wallet.svg" alt="" />
            <span>Payment Methods</span></router-link
          >
        </li>
        <li>
          <a href="#" data-bs-toggle="modal" data-bs-target="#logout_user"
            ><img src="/src/assets/images/logout.svg" alt="" />
            <span>Logout</span></a
          >
        </li>
      </ul>
    </div>

    <!-- logout Modal -->
    <div
      class="modal fade"
      id="logout_user"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="close_modal">
              <button type="button" data-bs-dismiss="modal" aria-label="Close">
                <i class="fi fi-rr-cross-small"></i>
              </button>
            </div>
            <div class="modal_content">
              <h2>Confirmation</h2>
              <p>Are you sure want to logout ?</p>
              <div class="modal_buttons">
                <button
                  type="button"
                  class="button secondary_button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  No
                </button>
                <button
                  type="button"
                  class="button primary_button"
                  @click.prevent="logout()"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApis from "../../Apis/users";
import { logOut } from "../../utils/auth";

export default {
  data() {
    return {
      loader: false,
    };
  },
  methods: {
    async logout() {
      this.loader = true;
      await userApis
        .logout()
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$store.dispatch("islogut", null);
            logOut();
            $("body").removeClass("modal-open");
            $(".fade").removeClass("modal-backdrop");
            $("body").css("padding-right", "0px");

            this.loader = false;
            this.$router.push({ name: "login" });
          }
        })
        .catch((error) => {
          this.loader = false;
        })
        .then(() => {
          this.loader = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/accounts/sidebar.vue